import PropTypes from "prop-types";

import { t } from "../../../services";
import { strCode } from "../../../consts";

import {
  FlexContainers,
  Heading4,
  Modal,
  Paragraph2,
  SmallButton,
  WrapperContainer
} from "../../../components";

const RemoveMarketModal = ({
  data,
  isLoading,
  isActive,
  setActive,
  onRemoveMarketCancel,
  onDeleteMarketConfirmation
}) => {
  return (
    <Modal
      id="remove-market-modal"
      active={isActive}
      preventOverflow
      closable={false}
      closeOnBackgroundClick
      setActive={setActive}>
      <WrapperContainer Container={FlexContainers.FlexColumn} width={614}>
        <WrapperContainer Container={FlexContainers.FlexRowStart} width="100%" mb={16}>
          <Heading4>{t(strCode.REMOVE_MARKET_QUESTION, { name: data?.name })}</Heading4>
        </WrapperContainer>

        <Paragraph2
          dangerouslySetInnerHTML={{
            __html: t(strCode.REMOVE_MARKET_INFO, {
              name: data?.name,
              activeUsers: data?.activeUserCount
            })
          }}></Paragraph2>

        <WrapperContainer Container={FlexContainers.FlexRowEnd} mt={24} width="100%" gap={16}>
          <SmallButton secondary disabled={isLoading} onClick={onRemoveMarketCancel}>
            {t(strCode.CANCEL_BTN)}
          </SmallButton>
          <SmallButton
            backgroundRed
            loading={isLoading}
            disabled={isLoading}
            onClick={() => onDeleteMarketConfirmation(data)}>
            {t(strCode.DELETE_BTN)}
          </SmallButton>
        </WrapperContainer>
      </WrapperContainer>
    </Modal>
  );
};

RemoveMarketModal.propTypes = {
  data: PropTypes.shape({
    country: PropTypes.string,
    market: PropTypes.string,
    name: PropTypes.string,
    activeUserCount: PropTypes.number
  }),
  isLoading: PropTypes.bool,
  isActive: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  onRemoveMarketCancel: PropTypes.func.isRequired,
  onDeleteMarketConfirmation: PropTypes.func.isRequired
};

export default RemoveMarketModal;
